import {
  Alert,
  Box,
  Button,
  Chip,
  Divider,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import CartCourseComponent from './CartCourseComponent';
import NoDataFound from '../../../../components/NodataIndication/NoDataFound';
import { motion } from 'framer-motion';
import PopuForm from './PopuForm';
import MotionContainer from '../../../../components/FramerMotion/MotionContainer';
import IsAvailableCartItems from './IsAvailableCartItems';
import { UpdateButton } from '../../../../components/mui/Buttons/Buttons';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getCartItems, UpdateCartItems } from '../../../../redux/features/cartSlice';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';
import PaidCartItems from './PaidCartItems';
import SlideToPay from '../../../../components/SlidingButton';
import PaymentMethodsPopup from './PaymentMethodsPopup';
import PaymentProcessingCourses from './PaymentProcessingCourses';
import CircularLoader from '../../../../components/Loader/CircularLoader';
import BulkNextPayment from './BulkNextPayment';

const CartCourses = ({
  totalCourses,
  setTotalCourses,
  paidCartItems,
  setAvailableCartItems,
  availableCartItems,
  changeValidation,
  paymentProcessingItems,
  currencyValidation,
}) => {
  const [totalDiscountedAmount, setTotalDiscountedAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [totalPayingAmount, setTotalPayingAmount] = useState(0);
  const [isAvailabletotalPayingAmount, setIsAvailableTotalPayingAmount] = useState(0);
  const [isVailablefilterCourseData, setIsVailableFilterCourse] = useState([]);
  const { cartItems } = useSelector((state) => state.cart);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.cart);
  const { enqueueSnackbar } = useSnackbar();

  const [zeroValidation, setZeroValidation] = useState(false);
  const [discountValidation, setDiscountValidation] = useState(false);
  const [payingAmountValidation, setPayingAmountValidation] = useState(false);
  const [classroomValidation, setClassroomValidation] = useState({
    isAvailable: false,
    newCourse: false,
  });
  // -------------------------------------------------------------------------

  const [availableZeroValidation, setAvailableZeroValidation] = useState(false);
  const [availableDiscountValidation, setAvailableDiscountValidation] = useState(false);
  const [availablePayingAmountValidation, setAvailablePayingAmountValidation] = useState(false);
  // ---------------------------payment-reciept-valifations----------------------------------------------

  const [paymentRecieptValidation, setPaymentRecieptValidation] = useState([]);

  useEffect(() => {
    if (paidCartItems.length > 0) {
      const notDownloadedData = paidCartItems
        .map((paidItem) => ({
          ...paidItem,
          CartPaymentLogs: paidItem.CartPaymentLogs.filter((log) => log.PaymentInvoice?.is_downloaded === 0),
        }))
        .filter((paidItem) => paidItem.CartPaymentLogs.length > 0);
      if (notDownloadedData.length > 0) {
        setPaymentRecieptValidation(notDownloadedData);
      } else {
        setPaymentRecieptValidation([]);
      }
    }
  }, [paidCartItems]);
  // ------------------------------------------------------------------------------------------------------

  const handleUpdate = () => {
    // Check if there are availableCartItems to validate
    if (availableCartItems && availableCartItems.length > 0) {
      // Perform validation for each item

      let hasEmptyFields = false;
      availableCartItems.forEach((item) => {
        if (
          !item.MRP ||
          // !item.discount ||
          !item.noOfSessions ||
          (!item.paidAmt && item.wishList == false)
        ) {
          enqueueSnackbar('Some fields are empty...!', {
            variant: 'error',
          });
          hasEmptyFields = true;
        }
      });

      // If there are empty fields, stop further processing
      if (hasEmptyFields) return;
    }

    if (availableCartItems && availableCartItems.length > 0) {
      const validation = availableCartItems.some((item) => item.subjects.length == 0);
      if (!validation) {
        const data = {
          leadId: location?.state.leadId,
          items: availableCartItems,
        };

        dispatch(UpdateCartItems(data)).then((res) => {
          if (res.payload.status === 'error') {
            enqueueSnackbar(res.payload.message, { variant: 'error' });
          } else if (res.payload.status === 'success') {
            dispatch(getCartItems(data.leadId));
            enqueueSnackbar(res.payload.message, {
              variant: 'success',
            });
          }
        });
      } else {
        enqueueSnackbar('Add subjects...!', {
          variant: 'error',
        });
      }
    }
  };
  // -----------------validation-------------------
  const [hasChanges, setHasChanges] = useState(false);

  useEffect(() => {
    const hasArrayDataChanged = (arr1, arr2) => {
      if (arr1.length !== arr2.length) return true;

      return arr1.some((obj, index) => {
        const obj2 = arr2[index];
        return Object.keys(obj).some((key) => obj[key] !== obj2[key]);
      });
    };
    setHasChanges(hasArrayDataChanged(changeValidation, availableCartItems));
  }, [availableCartItems, changeValidation]);
  const handlePaymentConfirm = () => {
    if (availableCartItems && availableCartItems.length > 0) {
      availableCartItems.forEach((item) => {
        if (!item.MRP || !item.discount || !item.noOfSessions || (!item.paidAmt && item.wishList == false)) {
          enqueueSnackbar('Some fields are empty...!', {
            variant: 'error',
          });
          setOpen(false);
        } else {
          setOpen(true);
        }
      });
    }
  };
  return (
    <Box sx={{ paddingTop: 2 }}>
      <Paper elevation={2} sx={{ borderRadius: 3, padding: 1, backgroundColor: '#fafaff' }}>
        <Box padding={2}>
          <Chip
            sx={{ backgroundColor: '#702dff', color: 'white' }}
            variant="contained"
            icon={<Icon icon="hugeicons:course" height={22} width={22} color="white" />}
            label={<Typography variant="h6">Details of Added Courses</Typography>}
          />
        </Box>
        <Box padding={1}>
          <GlobalWrapper>
            <PaidCartItems paidCartItems={paidCartItems} paymentRecieptValidation={paymentRecieptValidation} />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <BulkNextPayment paidCartItems={paidCartItems} />
            </Box>
            <PaymentProcessingCourses paymentProcessingItems={paymentProcessingItems} />
            {availableCartItems.length == 0 ? null : (
              <>
                <IsAvailableCartItems
                  availableCartItems={availableCartItems}
                  setAvailableCartItems={setAvailableCartItems}
                  setTotalCourses={setTotalCourses}
                  totalCourses={totalCourses}
                  totalDiscountedAmount={totalDiscountedAmount}
                  setTotalDiscountedAmount={setTotalDiscountedAmount}
                  setTotalDiscount={setTotalDiscount}
                  setTotalAmount={setTotalAmount}
                  setTotalPayingAmount={setTotalPayingAmount}
                  setIsVailableFilterCourse={setIsVailableFilterCourse}
                  setIsAvailableTotalPayingAmount={setIsAvailableTotalPayingAmount}
                  setAvailablePayingAmountValidation={setAvailablePayingAmountValidation}
                  setAvailableDiscountValidation={setAvailableDiscountValidation}
                  setAvailableZeroValidation={setAvailableZeroValidation}
                  availablePayingAmountValidation={availablePayingAmountValidation}
                  availableDiscountValidation={availableDiscountValidation}
                  availableZeroValidation={availableZeroValidation}
                  classroomValidation={classroomValidation}
                  setClassroomValidation={setClassroomValidation}
                />

                <MotionContainer delay={0.7}>
                  {availablePayingAmountValidation || availableDiscountValidation || availableZeroValidation ? null : (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        mt: 2,
                      }}
                    >
                      {hasChanges ? (
                        <>
                          <Button
                            onClick={handleUpdate}
                            disabled={
                              classroomValidation.newCourse ||
                              availableCartItems.some((item) => item.subjects.some((subject) => !subject.amountInr))
                            }
                            sx={{
                              color: 'white',
                              background: `linear-gradient(to bottom, #0089d0 0%, #0089d0 10%, #a125c2 100%)`,
                              borderRadius: 3,
                              width: 200,
                            }}
                          >
                            <Icon icon="grommet-icons:update" height={22} width={22} />
                            {loading ? (
                              <Box sx={{ display: 'flex' }}>
                                Please Wait... <CircularLoader />
                              </Box>
                            ) : (
                              ' Update Cart Items'
                            )}
                          </Button>
                        </>
                      ) : null}
                    </Box>
                  )}
                </MotionContainer>
                <MotionContainer delay={0.7}>
                  {availablePayingAmountValidation || availableDiscountValidation || availableZeroValidation ? null : (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        mt: 2,
                      }}
                    >
                      {hasChanges ? null : (
                        <>
                          {isVailablefilterCourseData?.length == 0 ? null : (
                            <SlideToPay onConfirm={handlePaymentConfirm} />
                          )}
                        </>
                      )}
                    </Box>
                  )}
                </MotionContainer>
                <PaymentMethodsPopup
                  isAvailabletotalPayingAmount={isAvailabletotalPayingAmount}
                  open={open}
                  availableCartItems={availableCartItems}
                  setOpen={setOpen}
                />
              </>
            )}
            <Box mt={2}>
              <Typography variant="h6">New Courses</Typography>
              <Divider sx={{ borderStyle: 'dashed', borderBottomWidth: 2 }} />
            </Box>
            {totalCourses.length !== 0 ? (
              <Box>
                <CartCourseComponent
                  setTotalCourses={setTotalCourses}
                  totalCourses={totalCourses}
                  totalDiscountedAmount={totalDiscountedAmount}
                  setTotalDiscountedAmount={setTotalDiscountedAmount}
                  setTotalDiscount={setTotalDiscount}
                  setTotalAmount={setTotalAmount}
                  setTotalPayingAmount={setTotalPayingAmount}
                  setPayingAmountValidation={setPayingAmountValidation}
                  payingAmountValidation={payingAmountValidation}
                  setDiscountValidation={setDiscountValidation}
                  discountValidation={discountValidation}
                  setZeroValidation={setZeroValidation}
                  zeroValidation={zeroValidation}
                  setClassroomValidation={setClassroomValidation}
                  classroomValidation={classroomValidation}
                />
                {currencyValidation.isValid ? (
                  <Box sx={{ pt: 2, pb: 2 }}>
                    <Alert severity="error">{currencyValidation.message}</Alert>
                  </Box>
                ) : null}

                <Box>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      padding: 2,
                      alignItems: 'self-start',
                    }}
                  >
                    <Stack direction={'column'} spacing={1} sx={{ alignItems: 'flex-end' }}>
                      <MotionContainer delay={0.5}>
                        <Box>
                          <Button sx={{ color: 'black' }}>
                            Total Amount :-
                            <Icon icon="mdi:currency-inr" height={22} width={22} />
                            {totalAmount}
                          </Button>
                          <Divider sx={{ borderStyle: 'dashed', borderBottomWidth: 2 }} />
                        </Box>
                      </MotionContainer>
                      <MotionContainer delay={0.7}>
                        <Box>
                          <Button sx={{ color: 'black' }}>
                            Total Discount :-
                            <Icon icon="mdi:currency-inr" height={22} width={22} />
                            {totalDiscount}
                          </Button>
                          <Divider sx={{ borderStyle: 'dashed', borderBottomWidth: 2 }} />
                        </Box>
                      </MotionContainer>
                      <MotionContainer delay={1}>
                        <Box>
                          <Button sx={{ color: 'black' }}>
                            Total Discounted Amount :-
                            <Icon icon="mdi:currency-inr" height={22} width={22} />
                            {totalDiscountedAmount}
                          </Button>
                          <Divider sx={{ borderStyle: 'dashed', borderBottomWidth: 2 }} />
                        </Box>
                      </MotionContainer>
                      <MotionContainer delay={1.2}>
                        <Box>
                          <Button sx={{ color: 'black' }}>
                            Total Paying Amount :-
                            <Icon icon="mdi:currency-inr" height={22} width={22} />
                            {totalPayingAmount}
                          </Button>
                          <Divider sx={{ borderStyle: 'dashed', borderBottomWidth: 2 }} />
                        </Box>
                      </MotionContainer>
                    </Stack>
                  </Box>
                </Box>
                {paymentRecieptValidation.length > 0 ? (
                  <Alert severity="error">
                    {
                      <Box>
                        {paymentRecieptValidation.map((paidItem, i) => {
                          return (
                            <Box key={i}>
                              <Typography variant="body2">
                                {`>${paidItem?.course_available?.course_name}- (Enrolled by :${paidItem.createdBy}) ` ||
                                  'Not Available'}
                              </Typography>
                              {/* {paidItem?.CartPaymentLogs.map((log) => { */}

                              <Box>
                                <TableContainer component={Paper} sx={{ maxWidth: 1000, margin: 'auto', mt: 4 }}>
                                  <Typography variant="h6" sx={{ p: 2 }}>
                                    Payment Logs
                                  </Typography>
                                  <Table>
                                    <TableHead>
                                      <TableRow>
                                        <TableCell>
                                          <strong>Invoice ID</strong>
                                        </TableCell>
                                        <TableCell>
                                          <strong>Payment Method</strong>
                                        </TableCell>
                                        <TableCell>
                                          <strong>Payable Amount</strong>
                                        </TableCell>
                                        <TableCell>
                                          <strong>Transaction Date</strong>
                                        </TableCell>
                                        <TableCell>
                                          <strong>Created By</strong>
                                        </TableCell>
                                        <TableCell>
                                          <strong>Created Date</strong>
                                        </TableCell>

                                        <TableCell>
                                          <strong>Paid Status</strong>
                                        </TableCell>
                                        <TableCell>
                                          <strong>Reciept Downloaded</strong>
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>

                                    <TableBody>
                                      {paidItem?.CartPaymentLogs?.map((item, index) => (
                                        <TableRow
                                          key={index}
                                          sx={{
                                            '&:nth-of-type(odd)': { backgroundColor: '#f9f9f9' },
                                          }}
                                        >
                                          <TableCell>{item.invoiceId}</TableCell>
                                          <TableCell>{item.paymentMethod}</TableCell>
                                          <TableCell>₹{item.payableAmt}</TableCell>
                                          <TableCell>{item.transactionDate}</TableCell>
                                          <TableCell>{item.createdBy.name}</TableCell>
                                          <TableCell>{item.createdDate}</TableCell>

                                          <TableCell>
                                            <Chip
                                              label={item.paidStatus ? 'Paid' : 'Unpaid'}
                                              color={item.paidStatus ? 'success' : 'error'}
                                              size="small"
                                            />
                                          </TableCell>
                                          <TableCell>
                                            <Chip
                                              label={
                                                item.PaymentInvoice.is_downloaded ? 'Downloaded' : 'Not Downloaded'
                                              }
                                              color={item.PaymentInvoice.is_downloaded ? 'success' : 'warning'}
                                              size="small"
                                            />
                                          </TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </Box>

                              {/* })} */}
                            </Box>
                          );
                        })}
                        <Typography>
                          Please check the payment logs of the mentioned enrolled courses. The payment receipts for
                          these courses have not been downloaded or shared with parents.
                        </Typography>
                      </Box>
                    }
                  </Alert>
                ) : (
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 2 }}>
                    <PopuForm
                      disabled={
                        payingAmountValidation ||
                        discountValidation ||
                        classroomValidation.newCourse ||
                        currencyValidation.isValid ||
                        zeroValidation
                          ? true
                          : false
                      }
                      totalPayingAmount={totalPayingAmount}
                      totalDiscountedAmount={totalDiscountedAmount}
                      totalCourses={totalCourses}
                      setTotalCourses={setTotalCourses}
                    />
                  </Box>
                )}
              </Box>
            ) : (
              <motion.div
                initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -50 }}
                transition={{ duration: 0.5 }}
              >
                <NoDataFound />
              </motion.div>
            )}
            <motion.div
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -50 }}
              transition={{ duration: 0.5 }}
            >
              <Box mt={2}>
                <Divider sx={{ borderStyle: 'dashed', borderBottomWidth: 2 }} />
                <Box sx={{ display: 'flex', justifyContent: 'center', pt: 1 }}>
                  <Chip
                    icon={<Icon icon="emojione-monotone:end-arrow" />}
                    size="small"
                    color="primary"
                    label={<Typography sx={{ fontSize: 10 }}>Cart items end</Typography>}
                    variant="outlined"
                    sx={{
                      borderColor: '#e3f2fd',
                      color: '#64b5f6',
                    }}
                  />
                </Box>
              </Box>
            </motion.div>
          </GlobalWrapper>
        </Box>
      </Paper>
    </Box>
  );
};

export default CartCourses;
